import React from 'react';
import type { Vocabulary } from '../../types/vocabulary.types';
import { Button } from '../common/Button';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  vocabulary: Vocabulary | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
}

export function DeleteConfirmModal({
  isOpen,
  vocabulary,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteConfirmModalProps): React.ReactElement | null {
  if (!isOpen || !vocabulary) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm animate-fade-in">
      <div className="w-full max-w-sm glass-card border-white/10 p-6 rounded-2xl shadow-2xl bg-surface-950/95 border text-slate-100">
        <div className="flex items-center gap-3 text-rose-400 mb-3">
          <div className="p-2.5 rounded-xl bg-rose-500/10 border border-rose-500/20">
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
            </svg>
          </div>
          <div>
            <h3 className="text-base font-bold text-white">Delete Vocabulary</h3>
            <p className="text-xs text-slate-400">This action cannot be undone.</p>
          </div>
        </div>

        <p className="text-sm text-slate-300 mb-5">
          Are you sure you want to delete{' '}
          <strong className="text-white font-semibold">&ldquo;{vocabulary.word}&rdquo;</strong>{' '}
          from your vocabulary collection?
        </p>

        <div className="flex items-center justify-end gap-2.5">
          <Button
            type="button"
            variant="ghost"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            id="confirm-delete-btn"
            type="button"
            variant="danger"
            onClick={() => void onConfirm()}
            loading={isDeleting}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
}
